import { render } from "./ExternalProviders.vue?vue&type=template&id=20f02c3e"
import script from "./ExternalProviders.vue?vue&type=script&lang=js"
export * from "./ExternalProviders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__